import { useCallback, useEffect, useState } from 'react';
import { getDistricts } from '../services/districts';

export function useDistricts({ enabled = true, stateId } = {}) {
  const [districts, setDistricts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDistricts = useCallback(async () => {
    if (!enabled) {
      setDistricts([]);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const res = await getDistricts(stateId ? { stateId } : undefined);
      setDistricts(res?.data?.districts || []);
    } catch (e) {
      setError(e?.message || 'Failed to load districts');
      setDistricts([]);
    } finally {
      setLoading(false);
    }
  }, [enabled, stateId]);

  useEffect(() => {
    fetchDistricts();
  }, [fetchDistricts]);

  return { districts, loading, error, refetch: fetchDistricts };
}
